<template>
  <v-stepper-content :step="7"
                     :class="$style.stepperContent">
    <div :class="$style.orderMain">
      <div :class="$style.orderMainInfo">
        <div :class="$style.backBtnContainer">
          <BaseButton :class="$style.orderBackBtn"
                      button-style="Back"
                      @click="previousStep">
            <svg v-svg
                 :class="$style.backIcon"
                 symbol="straight-arrow"/>
            <span>Back</span>
          </BaseButton>
        </div>

      </div>

      <div>
        <p :class="$style.orderMainStep">Optional</p>
        <div :class="$style.orderMainTitle">
          <h2 >Would you like to add fries?</h2>
        </div>

        <div :class="$style.dialogButtons">
          <BaseButton :class="$style.orderBackBtn"
                      button-style="Back"
                      @click="nextStep">
            Yes
          </BaseButton>
          <BaseButton :class="$style.orderBackBtn"
                      button-style="Back"
                      @click="finishOrderWithNoBundleItem">
            No
          </BaseButton>
        </div>
      </div>

    </div>

    <LoadingSpinner v-if="isLoading"/>
  </v-stepper-content>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';
import ConfiguratorMobileButtons from '@/apps/configurator/components/ConfiguratorMobileButtons';
import ConfiguratorHelpButton from '@/apps/configurator/components/ConfiguratorHelpButton';
import LoadingMixin from '@/lib/mixins/loading-mixin';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';
import { Getter, Action } from 'vuex-class';
import { CONFIGURATOR_UPDATE_ITEM } from '../store/types';
import OrderFinisherMixin from '../mixins/order-finisher-mixin';

const CURRENT_STEP = 7;

@Component({
  components: {
    LoadingSpinner,
    ConfiguratorHelpButton,
    BaseButton,
    ConfiguratorMobileButtons,
  },
  mixins: [
    LoadingMixin,
    OrderFinisherMixin,
  ],
})
export default class ConfiguratorStepBundleContent extends Vue {
  @Getter order;
  @Getter isGuest;
  @Getter isMobilePlatform;
  @Getter isKioskPlatform;
  @Action(CONFIGURATOR_UPDATE_ITEM) addItem;

  /**
   * Emit event to route configurator to the previous step.
   */
  previousStep() {
    this.$emit('stepChange', CURRENT_STEP - 1);
  }

  /**
   * Emit event to route configurator to the next step.
   */
  nextStep() {
    this.$emit('stepChange', CURRENT_STEP + 1);
  }

  /**
   * Finish order without bundle.
   */
  async finishOrderWithNoBundleItem() {
    const noBundleItem = {
      actionType:   2,
      bundleId:     21,
      categoryKey:  72,
      glutenFree:   false,
      images:       [],
      itemKey:      791,
      maxCount:     1,
      modifier:     null,
      modifiers:    [],
      name:         'No Bundle',
      orderIndex:   3,
      price:        0,
      productPrice: 0,
      quantity:     1,
      vegan:        false,
    };

    this.addItem(noBundleItem);
    this.finishOrder();
  }
}
</script>

<style lang="scss" module>
@import "~@/apps/configurator/styles/step-content.scss";


.dialogButtons {
  width: 480px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;

  button {
    width: 200px;
    padding: 20px;
  }

  @media screen and (max-width: $mobile-breakpoint-max) {
    width: 100%;
    flex-wrap: wrap;

    button {
      width: 100%;
      margin: 20px 0;
      padding: 14px 20px;

      div {
        font-size: 1.2rem;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/ConfiguratorStepBundleDialog.vue